import { ScanFace, BrainCircuit, FlaskConical, Waves } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { Reveal } from "@/components/site/Reveal";

const steps = [
  {
    icon: ScanFace,
    k: "01",
    t: "Measure",
    d: "GAZE scans your skin with your phone camera and reads it in seconds.",
    img: ASSETS.components.measureFace,
    pos: "object-center",
    bg: "bg-[#0e0b16]",
  },
  {
    icon: BrainCircuit,
    k: "02",
    t: "Understand",
    d: "The AI classifier localizes 11 distinct skin conditions across your face.",
    img: ASSETS.components.phoneAngled,
    pos: "object-center",
    bg: "bg-[#141019]",
  },
  {
    icon: FlaskConical,
    k: "03",
    t: "Personalize",
    d: "It selects the exact serum and dose — a sealed, NFC-tracked DOSE cartridge.",
    img: ASSETS.components.personalizeSerums,
    pos: "object-center",
    bg: "bg-[#0b0812]",
  },
  {
    icon: Waves,
    k: "04",
    t: "Deliver",
    d: "VIBE micro-jets it deep into the epidermis, then logs your skin's response.",
    img: ASSETS.components.deliverSkin,
    pos: "object-center",
    bg: "bg-[#0b0812]",
  },
];

export const HowItWorks = () => (
  <section id="how" className="relative py-28 md:py-40 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="mb-16">
        <Reveal>
          <p className="overline mb-5">The loop</p>
          <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-[-0.02em] max-w-2xl">
            Four steps, one continuous system.
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {steps.map((s, i) => (
          <Reveal key={s.k} delay={i * 0.09}>
            <div className="group h-full rounded-2xl border border-white/10 bg-card overflow-hidden hover:border-white/25 transition-colors duration-500">
              <div className={`hover-media relative overflow-hidden aspect-square ${s.bg}`}>
                <img src={s.img} alt={s.t} className={`absolute inset-0 w-full h-full object-cover ${s.pos}`} />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                <span className="absolute top-4 left-4 font-mono text-xs text-white/80">{s.k}</span>
              </div>
              <div className="p-7">
                <s.icon className="w-6 h-6 text-primary mb-6" strokeWidth={1.4} />
                <h3 className="font-serif text-3xl mb-2">{s.t}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
